import {
  TeamExternalIntegration,
  ResponseBodyEvaluation,
  PredicateType,
  EndpointResponse
} from 'types/api/status-checks/status-check'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'
import { ENDPOINT_URLS } from 'utils/third-party'

export const dataDogUS3StatusCheckIntegration: TeamExternalIntegration = {
  name: 'Datadog US3',
  type: IntegrationType.DatadogUS3,
  authUrl: `${ENDPOINT_URLS.datadog_us3}v2/current_user/application_keys`,
  isPrivateNetworkIntegration: false,
  headers: [
    { key: 'DD-API-KEY', value: '', label: 'API Key' },
    {
      key: 'DD-APPLICATION-KEY',
      value: '',
      label: 'Application Key'
    }
  ],
  url: ENDPOINT_URLS.datadog_us3,
  sortIndex: 0
}

export const datadogUS3MonitorRegex = new RegExp(
  '^https:\\/\\/(us3).datadoghq.com\\/(monitors|api/v1/monitor)\\/(.+\\d)'
)

export const datadogUS3ResponseBodyEvaluationConfiguration: ResponseBodyEvaluation =
  {
    op: 'AND',
    predicates: [
      {
        jpQuery: '.overall_state',
        type: 'String' as PredicateType,
        comparator: 'EQU',
        rValue: 'OK'
      }
    ]
  }

export function getDatadogUS3MonitorIdFromUrl(url: string): string {
  return datadogUS3MonitorRegex.exec(url)?.[3]
}

export function convertToDatadogUS3ApiUrl(url: string): string {
  if (datadogUS3MonitorRegex.test(url)) {
    const isAPIUrl = datadogUS3MonitorRegex.exec(url)?.[2] === 'api/v1/monitor'
    const monitorId = getDatadogUS3MonitorIdFromUrl(url)

    if (isAPIUrl) {
      return url
    }

    if (monitorId) {
      return `https://us3.datadoghq.com/api/v1/monitor/${monitorId}`
    }
  }

  return null
}

export function getDatadogUS3MonitorName(
  testEndpointResponse: EndpointResponse
): string {
  return JSON.parse(testEndpointResponse?.responseBody)?.name
}
